import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IChangeUserPasswordRequest } from '../models/models'

export class ChangePasswordApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'user/changeOwnPassword',
      requesterInfo,
    })
  }

  public async changePassword(request: IChangeUserPasswordRequest): Promise<boolean> {
    return await this.postAsync<boolean>(request)
  }
}
